import { render, staticRenderFns } from "./share-file.vue?vue&type=template&id=65fe2c81"
import script from "./share-file.vue?vue&type=script&lang=js"
export * from "./share-file.vue?vue&type=script&lang=js"
import style0 from "./share-file.vue?vue&type=style&index=0&id=65fe2c81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports